<template>
    <div class="com-item timeline-module" :key="index" :class="{ active: isactive == true }">
        <div class="component person-nav">
            <div class="van-sticky" :style="{
                backgroundColor: W.bgColor || 'transparent',
                color: W.textColor || '#333'
            }">


                <div class="public-module_title" v-if="W.enTitle || W.cnTitle">
                    <h2 class="module-cn" v-if="W.cnTitle">{{ W.cnTitle }}</h2>
                    <div class="module-en" v-if="W.enTitle">
                        <p class="module-line"></p>
                        {{ W.enTitle }}
                    </div>
                </div>



                <div class="timeline-module__body">

                    <div class="timeline-left">

                        <div class="timeline-module__arrow" @click="handPrev">
                            <i class="el-icon-arrow-left"></i>
                        </div>
                        <div class="timeline-module__arrow timeline-module__arrowRight" @click="handNext">
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </div>


                     <div v-if="swiperOption" class="slideWrap">
                        <swiper ref="mySwiper" :options="swiperOption" @slideChange="onSlideChange">
                            <swiper-slide v-for="(item, idx) in W.items" :key="idx">
                                <div
                                    class="slide-item"
                                    :class="{ active: idx === activeIndex, 'has-link': !!item.linkUrl }"
                                    @click="onItemClick(idx, item)"
                                >
                                    <!-- <h3 class="p_title">{{ item.year }}</h3> -->
                                    <h3 class="timeline-module__year">{{ item.year||" "}}</h3>
                                    <p class="timeline-module__title">{{ item.title ||" "}}</p>
                                    <p class="timeline-module__summary" v-if="item.summary">{{ item.summary||" "}}</p>
                                    <div class="timeline-module__imgWrap" v-if="item.imgUrl">
                                        <img :src="item.imgUrl" alt="" />
                                    </div>
                                </div>
                            </swiper-slide>
                        </swiper>
                    </div>


                    <!-- <button class="timeline-module__arrow timeline-module__arrow-left" @click="handPrev">
                        <i class="el-icon-arrow-left"></i>
                    </button>

                    <div class="timeline-module__slideWrap">
                        <swiper v-if="swiperOption" ref="mySwiper" :options="swiperOption" @slideChange="onSlideChange">
                            <swiper-slide v-for="(item, idx) in W.items" :key="idx">
                                <div class="timeline-module__card" :class="{ active: idx === activeIndex }">
                                    <h3 class="timeline-module__year">{{ item.year }}</h3>
                                    <p class="timeline-module__title">{{ item.title }}</p>
                                    <p class="timeline-module__summary" v-if="item.summary">{{ item.summary }}</p>
                                    <div class="timeline-module__imgWrap" v-if="item.imgUrl">
                                        <img :src="item.imgUrl" alt="" />
                                    </div>
                                </div>
                            </swiper-slide>
                        </swiper>
                    </div>

                    <button class="timeline-module__arrow timeline-module__arrow-right" @click="handNext">
                        <i class="el-icon-arrow-right"></i>
                    </button> -->
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

const DEFAULT_IMG = 'https://aes-mall-1257403518.cos.ap-guangzhou.myqcloud.com/202607/ScreenShot_2026-07-03_152303_32803152310271.png'

export default {
    name: 'timeline-module',
    components: { swiper, swiperSlide },
    props: {
        index: { type: Number },
        type: { type: String, default: 'preview' },
        isactive: { type: Boolean, default: false },
        phoneWidth: { type: Number, default: 1280 },
        proportion: { type: Number, default: 1 },
        modata: {
            type: Object,
            default: function () {
                return {
                    WName: 'timeline',
                    Title: '发展历程',
                    MID: 35,
                    ModuleName: 'timelineModule',
                    WContent: {}
                }
            }
        }
    },
    data() {
        return {
            activeIndex: 0,
            swiperOption: null,
            defaultData: {
                bgColor: '',
                textColor: '',
                activeColor: '#e60012',
                enTitle: 'COMPANY PROFILE',
                cnTitle: '发展历程',
                items: [
                    { year: '2003', title: '安亿仕成立\n专业汽车照明', summary: '', imgUrl: DEFAULT_IMG, linkUrl: '', linkName: '' },
                    { year: '2004', title: '生产 HID 安定器\n进驻阿里巴巴', summary: '', imgUrl: DEFAULT_IMG, linkUrl: '', linkName: '' },
                    { year: '2005', title: '进驻淘宝开店\nAES 氙气灯上架销售', summary: '', imgUrl: DEFAULT_IMG, linkUrl: '', linkName: '' },
                    { year: '2006', title: '进军汽车修理厂\n美容店批发市场', summary: '', imgUrl: DEFAULT_IMG, linkUrl: '', linkName: '' },
                    { year: '2007', title: '进军专业改灯市场', summary: '', imgUrl: DEFAULT_IMG, linkUrl: '', linkName: '' }
                ]
            }
        }
    },
    computed: {
        W: {
            get() { return this.modata.WContent || {} },
            set(val) { this.modata.WContent = val }
        }
    },
    watch: {
        'modata.WContent.items': {
            deep: true,
            handler() {
                this.$nextTick(() => this.buildSwiper())
            }
        }
    },
    mounted() {
        if (!this.modata.WContent) {
            this.$set(this.modata, 'WContent', {})
        }
        this.modata.WContent = Object.assign({}, this.defaultData, this.modata.WContent)
        if (!Array.isArray(this.modata.WContent.items) || !this.modata.WContent.items.length) {
            this.$set(this.modata.WContent, 'items', JSON.parse(JSON.stringify(this.defaultData.items)))
        }
        this.modata.WContent.items.forEach(item => {
            if (typeof item.linkUrl !== 'string') this.$set(item, 'linkUrl', '')
            if (typeof item.linkName !== 'string') this.$set(item, 'linkName', '')
        })
        this.$nextTick(() => this.buildSwiper())
    },
    methods: {
        swiperIns() {
            return this.$refs.mySwiper ? this.$refs.mySwiper.swiper : null
        },
        buildSwiper() {
            const total = (this.modata.WContent.items || []).length
            const opt = {
                autoplay: false,
                slidesPerView: total >= 5 ? 5 : (total > 0 ? total : 1),
                spaceBetween: 24,
                observer: true,
                observeParents: true,
                breakpoints: {
                    320: { slidesPerView: 1 },
                    768: { slidesPerView: 3 },
                    1100: { slidesPerView: 3 },
                    1400: { slidesPerView: 4 }
                }
            }
            this.swiperOption = opt
            if (this.swiperIns()) this.swiperIns().update()
        },
        onSlideChange() {
            // const ins = this.swiperIns()
            // if (!ins) return
            // this.activeIndex = ins.realIndex || 0
             if (!this.swiperIns()) return
            this.realIndex = this.swiperIns().realIndex || 0;
            this.activeIndex = this.swiperIns().realIndex || 0
        },
         handPrev() {
            //  this.activeIndex=this.activeIndex<=0?0:this.activeIndex-1;
            // if (this.swiperIns() && (this.realIndex-1)>=this.activeIndex){
            //     this.swiperIns().slidePrev()
            // } 
            if (this.activeIndex <= 0) return
            this.activeIndex = this.activeIndex - 1
            if (this.swiperIns()) this.swiperIns().slideToLoop(this.activeIndex, 300, false)
        },
        handNext() {
        //    this.activeIndex=this.activeIndex<=(this.modata.WContent.items.length-2)?this.activeIndex+1:this.activeIndex;
        //     if (this.swiperIns() && (this.realIndex+1)>=this.activeIndex) {
        //         this.swiperIns().slideNext()
        //     }
         const max = this.modata.WContent.items.length - 1
        if (this.activeIndex >= max) return
        this.activeIndex = this.activeIndex + 1
        if (this.swiperIns()) this.swiperIns().slideToLoop(this.activeIndex, 300, false)
             
        },
        handToSlide(index) {
            this.activeIndex = index || 0
            if (this.swiperIns()) this.swiperIns().slideToLoop(index, 1000, false)
        },
        onItemClick(idx, item) {
            if (item && item.linkUrl) {
                this.pageNavigate(item.linkUrl)
                return
            }
            this.handToSlide(idx)
        },
        pageNavigate(path) {
            if (!path) return
            if (/^(https?:|mailto:|tel:)/.test(path)) {
                window.open(path)
            } else if (this.$router) {
                this.$router.push(path)
            } else {
                window.location.href = path
            }
        }
        // handPrev() {
        //     const ins = this.swiperIns()
        //     if (ins) ins.slidePrev()
        // },
        // handNext() {
        //     const ins = this.swiperIns()
        //     if (ins) ins.slideNext()
        // }
    }
}
</script>

<style scoped lang="scss">
.timeline-module {
    margin-bottom: 30px;
    .van-sticky {
        width: 94%;
        max-width: 1600px;
        margin: 0 auto;
        padding: 2% 0;
    }

    .timeline-module__head {
        margin-bottom: 32px;
    }

    .timeline-module__cn {
        font-size: 28px;
        font-weight: bold;
        color: #333;
        line-height: 1.3;
        margin: 0 0 8px;
    }

    .timeline-module__line {
        width: 48px;
        height: 3px;
        background: #e60012;
        margin: 0 0 12px;
    }

    .timeline-module__en {
        font-size: 14px;
        color: #999;
        letter-spacing: 2px;
        line-height: 1.4;
        margin: 0;
    }

    .timeline-module__body {
        position: relative;
        display: flex;
        align-items: center;
    }

    .timeline-module__slideWrap {
        flex: 1;
        min-width: 0;
        overflow: hidden;
    }

    .timeline-left{
        flex: 0 0 25%;
        max-width: 200px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .timeline-module__arrow {
        width: 40px;
        height: 40px;
        flex: none;
        border-radius: 5px;
        box-shadow:  0 0 5px #dedede;
        border: 2px solid #ddd;
        background: #fff;
        color: #333;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s;

        &+.timeline-module__arrow{
            margin-left: 10px;
        }

        i {
            font-weight: 700;
            font-size: 18px;
        }

        &:hover {
            border-color: #e60012;
            color: #e60012;
        }

    }
    .timeline-module__arrowRight{
         color: #e60012;
    }

    .timeline-module__arrow-left {
        margin-right: 16px;
    }

    .timeline-module__arrow-right {
        margin-left: 16px;
    }

    .timeline-module__card {
        background: #fff;
        padding: 24px 16px;
        text-align: center;
        transition: all 0.3s;
        border-radius: 4px;
        min-height: 280px;
    }

    .timeline-module__year {
        font-size: 28px;
        font-weight: bold;
        color: #999;
        margin: 0 0 12px;
        transition: color 0.3s;
    }

    .timeline-module__card.active .timeline-module__year {
        color: #e60012;
    }

    .timeline-module__title {
        font-size: 14px;
        color: #333;
        line-height: 1.6;
        margin: 0 0 8px;
        white-space: pre-wrap;
        min-height: 48px;
    }

    .timeline-module__summary {
        font-size: 12px;
        color: #999;
        line-height: 1.5;
        margin: 0 0 12px;
    }

    .timeline-module__imgWrap {
        width: 100%;
        height: 140px;
        overflow: hidden;
        background: #f5f5f5;
        border-radius: 4px;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }



}




.slideWrap {
    width: 100%;
    margin: 0 0 50px;
    overflow: hidden;
    position: relative;
}

.slideWrap::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    height: 1px;
    background: #dfdfdf;
    bottom: 10px;
}

.slide-item {
    padding: 0 0 38px;
}

.slide-item.has-link {
    cursor: pointer;
}

.slide-item.active .timeline-module__year {
    color: var(--main-color);
}


.slide-item::after {
    content: '';
    position: absolute;
    bottom: 5px;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    border: 2px solid var(--main-color);
    width: 10px;
    height: 10px;
    border-radius: 100%;
    cursor: pointer;
}

.slide-item.active::after {
    background: var(--main-color);

    width: 14px;
    height: 14px;
    bottom: 3px;
}



@media screen and (max-width: 768px) {
    .timeline-module {
        margin-bottom: 0;
        .timeline-module__body {
            flex-direction: row;
        }

        .timeline-module__arrow {
            width: 36px;
            height: 36px;
        }

        .timeline-module__track {
            margin: 24px 40px 0;
        }
        .timeline-module__title{
            height: 50px;
            overflow: hidden;
          isplay: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        }
    }
}
</style>